import { useCallback, type MouseEvent } from "react";

import { useGo } from "../app/use-go.js";

/** 行の中で、押されたら行の遷移を譲る相手。 */
const interactive = "a, button, input, select, textarea, label, form, [role=button]";

const hasSelection = (): boolean =>
    (globalThis.getSelection()?.toString() ?? "").length > 0;

/**
 * 表の行をどこでも押せるようにする（行に <c>tr[data-row-href]</c> で行き先を持たせる）。
 *
 * <b>ClientApp の処理は React が描いた行を拾えない</b>（読み込んだ時点の行にしか付かない）ため、ここで持つ。
 * <b>行の中の「開く」は残すこと</b>——キーボードと読み上げはその本物のリンクを辿る。
 * 文字を選んだだけのときは移らない。修飾キーは別のタブで開く。
 */
export const useRowLink = (): ((href: string) => (event: MouseEvent<HTMLTableRowElement>) => void) => {
    const go = useGo();

    return useCallback((href: string) => (event: MouseEvent<HTMLTableRowElement>) => {
        // 行の中のリンクやボタンが押されたときは、そちらに任せる
        if (event.target instanceof Element && event.target.closest(interactive) !== null) {
            return;
        }
        if (hasSelection()) {
            return;
        }
        if (event.ctrlKey || event.metaKey || event.shiftKey) {
            globalThis.open(href, "_blank", "noopener");
            return;
        }
        go(href);
    }, [go]);
};
